import { useSelector } from 'react-redux';

import { rankingWithUserDataSelector } from '@lootboy/lib/slices/cardCollections/collectionRanking';
import {
  hasUserData,
  isRankingItemFetched,
  TExtendedRankingSliceItem,
} from '@lootboy/lib/slices/cardCollections/types';
import { TStore } from '@lootboy/lib/types/store';

import { ListContainer } from '~/components/atoms/ListContainer';
import BottomSheetDialog from '~/components/molecules/BottomSheetDialog';

import { TUseBooleanFunction } from '~/hooks/useBooleanState';
import { useIsRadarEnabled } from '~/redux/hooks/useIsRadarEnabled';
import { CollectionRankingEntry } from '~/views/CollectionView/CollectionRanking/CollectionRankingEntry';

import styles from './CollectionUserRankPopup.module.scss';

type TCollectionUserRankPopupProps = {
  close: TUseBooleanFunction;
  openChatRadarDialog: TUseBooleanFunction;
  collectionName: string;
  collectionId: string;
  openRankingDesyncDialog: TUseBooleanFunction;
  userCollectionValue: number;
};

export function CollectionUserRankPopup({
  collectionName,
  collectionId,
  close,
  openChatRadarDialog,
  userCollectionValue,
  openRankingDesyncDialog,
}: TCollectionUserRankPopupProps): JSX.Element {
  const isChatRadarAvailable = useIsRadarEnabled();
  const ranking = useSelector<TStore, TExtendedRankingSliceItem>((state) =>
    rankingWithUserDataSelector(state, collectionId),
  );
  const isRankingFetched = isRankingItemFetched(ranking);
  const userRanking = isRankingFetched && hasUserData(ranking) && ranking.rank;

  if (!userRanking) {
    return <></>;
  }

  const { related } = ranking;

  return (
    <BottomSheetDialog
      onClose={close}
      header={collectionName}
    >
      <ListContainer className={styles.container}>
        {related.map((entry) => {
          const { isUserEntry, avatar } = entry;

          const shouldClickOpenRadarDialog =
            isChatRadarAvailable && isUserEntry && !avatar;

          return (
            <CollectionRankingEntry
              key={`${entry.username}_${entry.no}`}
              rankingEntry={entry}
              onClick={
                shouldClickOpenRadarDialog ? openChatRadarDialog : undefined
              }
              onPositionIconClick={
                isUserEntry && entry.value !== userCollectionValue
                  ? openRankingDesyncDialog
                  : undefined
              }
              showRadarIcon={isUserEntry && !avatar}
            />
          );
        })}
      </ListContainer>
    </BottomSheetDialog>
  );
}
